import { Component, Input } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { getISOWeek } from 'date-fns';
import { NzSelectPlacementType } from 'ng-zorro-antd/select';

@Component({
  selector: 'app-input-rangepicker',
  templateUrl: './input-rangepicker.component.html',
  styleUrl: './input-rangepicker.component.scss',
})
export class InputRangepickerComponent {
  @Input() placeholder: string = 'Select a date';
  @Input() isDisabled: boolean = false;
  @Input() label: string = '';
  @Input() control: FormControl = new FormControl();
  @Input() size: 'default' | 'large' | 'small' = 'small';
  @Input() placement: NzSelectPlacementType = 'topLeft';
  date = null;

  onChange(result: Date[]): void {
    console.log('onChange: ', result);
  }

  getWeek(result: Date[]): void {
    console.log('week: ', result.map(getISOWeek));
  }

  isRequired(control: AbstractControl | null): boolean {
    if (!control || !control.validator) {
      return false;
    }
    const validator = control.validator({} as AbstractControl);
    return validator && validator['required'] ? true : false;
  }
}
